<template>
	<core-layout-headline-with-tabs :tabs="tabs">{{ $t("participants") }}</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"
import { can } from "@/permissions/"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const output = [
				{
					name: this.$t("overview"),
					to: {
						name: "InternalsDetail",
						params: { id: this.$route.params.id }
					}
				},
				{
					name: this.$t("subscriptions"),
					to: {
						name: "InternalSubscriptions",
						params: { id: this.$route.params.id }
					}
				}
			]
			return output
		}
	}
}
</script>
